module.exports = __webpack_public_path__ + "static/img/guarantee.77554df4.png";